import React from "react";
import { Col, Container, Row } from "reactstrap";
import WhyIcmFirst from "../assets/svgs/WhyIcmFirst"
import WhyIcmSecond from "../assets/svgs/WhyIcmSecond";
import WhyIcmThird from "../assets/svgs/WhyIcmThird";
import WhyIcmFourth from "../assets/svgs/WhyIcmFourth";
import WhyIcmFifth from "../assets/svgs/WhyIcmFifth";
import WhyIcmSixth from "../assets/svgs/WhyIcmSixth";

export default function WhyIcm(props) {
  const determineImage = (index) => {
    switch (index) {
      case 1:
        return <WhyIcmFirst />;
      case 2:
        return <WhyIcmSecond />;
      case 3:
        return <WhyIcmThird />;
      case 4:
        return <WhyIcmFourth />;
      case 5:
        return <WhyIcmFifth />;
      case 6:
        return <WhyIcmSixth />;
      default:
        return null;  
    }
  }
  return (
    <div className="why-icm-main">
      <Container className="why-icm-sub-main">
        <p className="main-title text-center">
          {props?.whyIcm?.title}
        </p>
        {props?.mldAssetDetails?.whyInvest?.split('|').length > 0 &&
          <Row className="">
            {props.mldAssetDetails?.whyInvest.split('|').map((item, index) => (
              <Col className="why-icm-item" lg={6} xl={6} sm={11} xs={11} md={11}>
                {determineImage(index + 1)}
                <p
                  className="mb-0"
                  dangerouslySetInnerHTML={
                    { __html: item }
                  }
                />
              </Col>
            ))}
          </Row>
        }
      </Container>
    </div>
  )
}